.footer {
  background-color: #2D3748;
  color: white;
  margin-top: auto;
  padding: 40px 0 20px;
}

.footerContent {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.footerSection h3 {
  color: #635BFF;
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.footerSection h4 {
  color: #E2E8F0;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.footerSection p {
  color: #A0AEC0;
  line-height: 1.6;
  margin: 0;
}

.footerLinks {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footerLinks li {
  margin-bottom: 8px;
}

.footerLink {
  color: #A0AEC0;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footerLink:hover {
  color: #635BFF;
}

.footerBottom {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
  border-top: 1px solid #4A5568;
  margin-top: 30px;
}

.footerBottom p {
  color: #A0AEC0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.heart {
  color: #E53E3E;
  animation: heartbeat 1.5s ease-in-out infinite;
}

@keyframes heartbeat {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

/* Responsive design */
@media (max-width: 768px) {
  .footerContent {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .footerBottom p {
    flex-direction: column;
    gap: 4px;
  }
}